import { AxiosResponse } from "axios";

export { default as ImportDocumentation } from "./ImportDocumentation";

export const getContentDispositionFileName = (response: AxiosResponse) =>
  response.headers["content-disposition"].split("filename=")[1];
